import API, { type ApiOptions } from '@/api/base';

export interface GetVideosRequestBody {
  start: string;
  end: string;
  keyword: string;
  group_id?: number | '';
  skip_cache: boolean;
  page?: number;
  limit?: number;
  isLabeled?: boolean;
}

export interface UploadVideoRequestBody {
  name: string;
  description: string;
  shot_date: string;
  acl: number[];
  acl_dl: number[];
  encoded?: boolean;
}

export interface UpdateVideoRequestBody {
  name: string;
  description: string;
  shot_date: string;
  acl: number[];
  acl_dl: number[];
}

const Video = {
  // 映像一覧取得
  getVideoList: async (data?: GetVideosRequestBody) => {
    const options: ApiOptions = {
      method: 'GET',
      url: `/new_eve/video/get_videos`,
      params: data
    };
    return await API.request(options);
  },

  // 映像取得
  getVideo: async (video_id: number, include_data: boolean = false) => {
    const options: ApiOptions = {
      method: 'GET',
      url: `/new_eve/video/get_video/${video_id}`,
      params: { include_data }
    };
    return await API.request(options);
  },

  getDownloadURL: async (video_id: number) => {
    const options: ApiOptions = {
      method: 'GET',
      url: `/new_eve/url/download/${video_id}`
    };
    return await API.request(options);
  },

  getUpload: async (upload_id: number) => {
    const options: ApiOptions = {
      method: 'GET',
      url: `/new_eve/upload/${upload_id}`
    };
    return await API.request(options);
  },

  // 映像をDBに登録
  uploadVideo: async (data: UploadVideoRequestBody) => {
    const options: ApiOptions = {
      method: 'POST',
      url: `/new_eve/video/0`,
      data
    };
    return await API.request(options);
  },

  // 映像をアップロード
  postUploadURL: async (upload_id: number, data: unknown, apiOptions?: ApiOptions) => {
    const options: ApiOptions = {
      method: 'POST',
      url: `/new_eve/upload/${upload_id}`,
      data,
      ...apiOptions
    };
    return await API.request(options);
  },

  // 映像を更新
  updateVideo: async (video_id: number, data: unknown, apiOptions?: ApiOptions) => {
    const options: ApiOptions = {
      method: 'POST',
      url: `/new_eve/video/${video_id}`,
      data,
      ...apiOptions
    };
    return await API.request(options);
  },

  checkVideoHash: async (video_id: number, hash: string) => {
    const options: ApiOptions = {
      method: 'POST',
      url: `/new_eve/video/${video_id}?oper=hash`,
      data: {
        hash
      }
    };
    return await API.request(options);
  },

  // 映像とゲームデータを紐づける
  updateVideoTieGameData: async (video_id: number, data: string) => {
    const options: ApiOptions = {
      method: 'POST',
      url: `/new_eve/video/${video_id}?oper=data`,
      data: {
        data: data
      }
    };
    return await API.request(options);
  },

  // 映像を削除
  deleteVideo: async (video_id: number) => {
    const options: ApiOptions = {
      method: 'DELETE',
      url: `/new_eve/video/${video_id}`
    };
    return await API.request(options);
  },

  // regen thumbnail
  regenThumbnail: async (video_id: number) => {
    const options: ApiOptions = {
      method: 'POST',
      url: `/new_eve/video/regen_thumbnail/${video_id}`
    };
    return await API.request(options);
  }
};

export default Video;
